import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import PropertyTablePicker from './components/PropertyTablePicker';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BaseFeature from './BaseFeature';
import { CONSTANT_LUMEN_OUTPUT } from '../../../../../../utils/constantFeatures';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { Trans, withTranslation } from 'react-i18next';

class ConstantLumen extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[CONSTANT_LUMEN_OUTPUT.enable].value === "1" ? true : false,
            properties: Object.assign({}, this.props.properties)
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChartChange = this.handleChartChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        this.setState({ properties: this.props.properties });

        if (this.getCorrectPropertyName(propertyName) === CONSTANT_LUMEN_OUTPUT.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    handleChartChange(d, i) {

        this.props.handleChange(`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i + 1}`, d.y);
        this.props.handleChange(`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i + 1}`, d.x);

        this.setState({ properties: this.props.properties });
    }

    getmaxKh() {

        let max = 0;

        let i = 1;
        while (this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`] !== undefined
            && this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`] !== null) {

            const value = parseInt(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`].value);
            if (value > max) {
                max = value;
            }

            i++;
        }

        //Needed to have full width in case of only 1 column
        if(max === 0) {
            return 50;
        }

        return max;
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    getPercentage() {

        let areaTotal = 0;
        let areaSaved = 0;

        let minT = null;
        let minL = null;
        let maxT = null;
        let maxL = null;

        let i = 1;
        while (i < 9 && this.isOn(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`])
            && this.isOn(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i}`])) {

            const valueT = parseInt(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`].value);
            if (valueT > maxT || maxT === null) {
                maxT = valueT;
            }
            if (valueT < minT || minT === null) {
                minT = valueT;
            }

            const valueL = parseInt(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i}`].value);
            if (valueL > maxL || maxL === null) {
                maxL = valueL;
            }
            if (valueL < minL || minL === null) {
                minL = valueL;
            }

            i++;
        }

        areaTotal = maxL * maxT;

        i = 2;
        while (i < 9 && this.isOn(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`])
            && this.isOn(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i}`])) {

            const tPrec = this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i - 1}`].value;
            const lPrec = this.props.properties[`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i - 1}`].value;

            const tAct = this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}${i}`].value;
            const lAct = this.props.properties[`${CONSTANT_LUMEN_OUTPUT.outputLevel}${i}`].value;

            areaSaved += ((tAct - tPrec) * (lAct - lPrec) / 2) + ((maxL - lAct) * (lAct - lPrec));

            i++;
        }

        return Math.round(areaSaved / areaTotal * 100);
    }

    getEnergySavingPotential() {
        const { t } = this.props;
        if (this.isOn(this.props.properties[`${CONSTANT_LUMEN_OUTPUT.operatingTime}2`]) && this.props.validationSummary.isValid) {
            const { t, i18n } = this.props;
            const currentLanguage = i18n.language;
            if(currentLanguage === 'zh')
                return `${this.getmaxKh()}kh ${t('energy_saving_in')}${t('Up_to')} ${this.getPercentage()}%`;
            else
                return `${t('Up_to')} ${this.getPercentage()}% ${t('energy_saving_in')} ${this.getmaxKh()}kh`;
        } else {
            return t('Cons_Lum_Eng_Savings');
        }
    }

    getDataChart(properties) {

        let dataChart = [{}, {}, {}, {}, {}, {}, {}, {}];

        // Get X's and Y's from props
        Object.keys(properties).sort().forEach((key) => {
            if (properties[key].info.name.startsWith(CONSTANT_LUMEN_OUTPUT.outputLevel)) {
                const n = key.replace(CONSTANT_LUMEN_OUTPUT.outputLevel, '');
                if (n === '1' && properties[key].value === 'Off') {
                    dataChart[+n - 1].y = '70';
                } else {
                    dataChart[+n - 1].y = properties[key].value;
                }
            } else if (properties[key].info.name.startsWith(CONSTANT_LUMEN_OUTPUT.operatingTime)) {
                const n = key.replace(CONSTANT_LUMEN_OUTPUT.operatingTime, '');
                if (n === '1') {
                    dataChart[+n - 1].x = '0';
                } else {
                    dataChart[+n - 1].x = properties[key].value;
                }
            }
        });

        // Setting data for the chart
        dataChart = dataChart.filter((d) => d.x && d.y && d.x !== "Off" && d.y !== "Off");

        if (dataChart.length < 2) {
            dataChart.push({
                x: 50,
                y: dataChart[0].y
            });
        }

        return dataChart;
    }

    componentDidUpdate(prevProps) {
        if (this.props.properties !== prevProps.properties
                && this.props.properties[CONSTANT_LUMEN_OUTPUT.enable].value !== prevProps.properties[CONSTANT_LUMEN_OUTPUT.enable].value) {
            this.setState({
                isEnabled: this.props.properties[CONSTANT_LUMEN_OUTPUT.enable].value === "1" ? true : false,
                properties: Object.assign({}, this.props.properties),
            });
        }
    }

    render() {

        const clmEn = this.props.properties[CONSTANT_LUMEN_OUTPUT.enable];

        const className = super.getClassName(this.props.properties);

        const { t } = this.props;

        const dataChart = this.getDataChart(this.props.properties);
        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Constant_Lumen" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', minWidth: '150px' }}>
                            <PropertySwitch
                                property={clmEn}
                                title={clmEn.info.displayName}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>

                    <Card className={className}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {<Trans i18nKey="Levels_Times" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyTablePicker
                                disabled={!this.state.isEnabled}
                                properties={this.props.properties}
                                handleChange={this.handleChange}
                                sizeTitle={3}
                                sizePickers={1}
                                sizeMeasureUnit={1}
                                firstRow={{ 'title': t('Output_Level'), 'property': 'clm.l', 'measureUnit': '%' }}
                                secondRow={{ 'title': t('Operating_Time'), 'property': 'clm.t', 'measureUnit': 'kh' }} />
                        </Card.Body>
                    </Card>

                    <Card className="card-feature-component" style={{ marginRight: '0' }}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Energy_Saving_Potential" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {this.getEnergySavingPotential()}
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{ marginRight: '0', width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                disabled={!this.state.isEnabled}
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                x={{ 'title': t('Operating_Time') + '(kh)'}}
                                y={{ 'title': t('Output_Level') + '(%)'}}
                                max={{ x: this.getmaxKh(), y: 100 }}
                                min={{ x: 0, y: 0 }}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ConstantLumen);

export default compose(
    connect(mapStateToProps,mapDispatchToProps),
    withTranslation()
)(ConstantLumen);
